module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('strong', [_vm._v("Outstanding critical praise for"), _c('br'), _vm._v("Homer Hickam and "), _c('em', [_vm._v("The Keeper’s Son")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“A novel of adventure and romance set on this imaginary isle of wild horses, offbeat townsfolk, and the colorful crew of a Coast Guard patrol boat . . . [a] page-turning story of loss, courage, and providence.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—The Wall Street Journal")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well-crafted characters, gripping naval warfare, and colorful island life come together in this dynamic and exciting tale.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—"), _c('em', [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hickam brings it all off flawlessly . . . making the reader believe extraordinary events are indeed possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Roanoke Times")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“[An] irresistibly romantic WWII adventure . . . certain to seduce armchair sailors.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—"), _c('em', [_vm._v("Kirkus Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“In this excellent story of World War II on the Outer Banks, Hickam deftly crafts a romantic, even melodramatic story . . . the pacing, the building of character with carefully chosen detail, and the masterful construction of a setting . . . evokes with great skill a time and a place that is passing out of living memory.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—"), _c('em', [_vm._v("Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“With this book, Hickam expands his range . . . into the realm of fiction in a compelling novel of war, romance, haunting guilt, victory. Thrilling.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—Robert Morgan, bestselling author of"), _c('br'), _c('em', [_vm._v("Gap Creek")]), _vm._v(" and "), _c('em', [_vm._v("Brave Enemies")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hickam’s recollections of small-town America . . . are so cinematic that even those of us who didn’t grow up there imagine we did.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—The Philadelphia Inquirer")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a088458","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter.vue
// module id = 57
// module chunks = 0